export const SearchEntityVersionFragment = gql`
  fragment SearchEntityVersionFragment on EntityVersion {
    id
    entity {
      ...SearchEntityFragment
    }
    intersectingAddresses: intersectingEntities(type: Address) {
      ...SearchEntityFragment
    }
    intersectingParcels: intersectingEntities(type: Parcel) {
      ...SearchEntityFragment
    }
    searchableFields {
      ...EntityFieldFragment
    }
  }
  fragment SearchEntityFragment on Entity {
    id
    name
    uuid
    layer {
      id
      type
    }
  }
`

export const SearchEntityVersionsByBoundingBoxFragment = gql`
  fragment SearchEntityVersionsByBoundingBoxFragment on EntityVersion {
    ...SearchEntityVersionFragment
    coordinates {
      latitude
      longitude
    }
  }
`

export const SearchEntityVersionsByLocationFragment = gql`
  fragment SearchEntityVersionsByLocationFragment on EntityVersion {
    ...SearchEntityVersionFragment
    coordinates {
      latitude
      longitude
    }
  }
`

export const SearchEntityVersionsByCoordinateFragment = gql`
  fragment SearchEntityVersionsByCoordinateFragment on EntityVersion {
    id
    coordinates {
      latitude
      longitude
    }
    entity {
      id
      name
    }
  }
`

export const EntityVersionWithFieldsFragment = gql`
  fragment EntityVersionWithFieldsFragment on EntityVersion {
    id
    fieldsForEntityVersionAndIntersectingEntityVersions {
      ...EntityFieldFragment
    }
  }
`
